<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>
    <!-- Start right Content here -->
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Add New Employee</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)" @click="gotTo('employee-register')">Employees</a></li>
                    <li class="breadcrumb-item active">New Employee</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Form -->
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <!-- Main Card -->
              <div class="card">
                <div class="card-header bg-light">
                  <h5 class="mb-0 text-dark">
                    <i class="mdi mdi-account-plus me-2"></i>
                    Employee Registration Form
                  </h5>
                </div>

                <div class="card-body">
                  <!-- Mandatory Fields Section -->
                  <div class="mandatory-section">
                    <!-- Personal Information -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-account-circle me-2"></i>
                            Personal Information (Required)
                          </h6>
                        </div>
                      </div>

                      <!-- Title -->
                      <div class="col-md-6 col-lg-3 mb-3">
                        <label class="form-label">
                          Title <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-badge"></i></span>
                          <select
                              v-model="employee.title"
                              class="form-select"
                              :class="{'is-invalid': errors.title}"
                              @change="validateField('title')"
                          >
                            <option value="">Select Title</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Ms">Ms</option>
                            <option value="Dr">Dr</option>
                            <option value="Prof">Prof</option>
                          </select>
                        </div>
                        <small v-if="errors.title" class="text-danger">{{ errors.title }}</small>
                      </div>

                      <!-- Employee Number -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Employee Number <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-identifier"></i></span>
                          <input
                              v-model="employee.empNo"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.empNo}"
                              placeholder="e.g., EMP001"
                              @blur="validateField('empNo')"
                          >
                        </div>
                        <small v-if="errors.empNo" class="text-danger">{{ errors.empNo }}</small>
                      </div>

                      <!-- First Name -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          First Name <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                          <input
                              v-model="employee.firstName"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.firstName}"
                              placeholder="Enter first name"
                              @blur="validateField('firstName')"
                          >
                        </div>
                        <small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
                      </div>

                      <!-- Middle Name -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Middle Name
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                          <input
                              v-model="employee.middleName"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.middleName}"
                              placeholder="Enter middle name"
                              @blur="validateField('middleName')"
                          >
                        </div>
                        <small v-if="errors.middleName" class="text-danger">{{ errors.middleName }}</small>
                      </div>

                      <!-- Last Name -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Last Name <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                          <input
                              v-model="employee.lastName"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.lastName}"
                              placeholder="Enter last name"
                              @blur="validateField('lastName')"
                          >
                        </div>
                        <small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
                      </div>

                      <!-- Email -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Work Email <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-email"></i></span>
                          <input
                              v-model="employee.email"
                              type="email"
                              class="form-control"
                              :class="{'is-invalid': errors.email}"
                              placeholder="email@company.com"
                              @blur="validateField('email')"
                          >
                        </div>
                        <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
                      </div>

                      <!-- Personal Email (mandatory for Contract/Consultant/Intern) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Personal Email
                          <span v-if="requiresPersonalEmail" class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-email-outline"></i></span>
                          <input
                              v-model="employee.personalEmail"
                              type="email"
                              class="form-control"
                              :class="{'is-invalid': errors.personalEmail}"
                              placeholder="personal@gmail.com"
                              @blur="validateField('personalEmail')"
                          >
                        </div>
                        <small v-if="errors.personalEmail" class="text-danger">{{ errors.personalEmail }}</small>
                        <small v-else-if="requiresPersonalEmail" class="text-muted">Required for {{ employee.employmentType }}</small>
                      </div>

                      <!-- Phone -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Phone Number <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-phone"></i></span>
                          <input
                              v-model="employee.phone"
                              type="tel"
                              class="form-control"
                              :class="{'is-invalid': errors.phone}"
                              placeholder="07XXXXXXXX"
                              @blur="validateField('phone')"
                          >
                        </div>
                        <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                      </div>

                      <!-- National ID -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          National ID <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-card-account-details"></i></span>
                          <input
                              v-model="employee.nationalId"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.nationalId}"
                              placeholder="Enter ID number"
                              @blur="validateField('nationalId')"
                          >
                        </div>
                        <small v-if="errors.nationalId" class="text-danger">{{ errors.nationalId }}</small>
                      </div>
                    </div>

                    <!-- Address & Disability -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-home-account me-2"></i>
                            Contact & Address Details
                          </h6>
                        </div>
                      </div>

                      <!-- Person with Disability? -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Person with Disability? <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-wheelchair-accessibility"></i></span>
                          <select
                              v-model="employee.disabilityStatus"
                              class="form-select"
                              :class="{'is-invalid': errors.disabilityStatus}"
                              @change="validateField('disabilityStatus')"
                          >
                            <option value="">Select Option</option>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </select>
                        </div>
                        <small v-if="errors.disabilityStatus" class="text-danger">{{ errors.disabilityStatus }}</small>
                      </div>

                      <!-- Disability ID -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Disability ID
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-card-account-details-star"></i></span>
                          <input
                              v-model="employee.disabilityId"
                              type="text"
                              class="form-control"
                              placeholder="Enter Disability ID"
                          >
                        </div>
                      </div>

                      <!-- Postal Code -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Postal Code <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-email-outline"></i></span>
                          <input
                              v-model="employee.postalCode"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.postalCode}"
                              placeholder="Enter Postal Code"
                              @blur="validateField('postalCode')"
                          >
                        </div>
                        <small v-if="errors.postalCode" class="text-danger">{{ errors.postalCode }}</small>
                      </div>

                      <!-- Postal Town -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Postal Town <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-city"></i></span>
                          <input
                              v-model="employee.postalTown"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.postalTown}"
                              placeholder="Enter Postal Town"
                              @blur="validateField('postalTown')"
                          >
                        </div>
                        <small v-if="errors.postalTown" class="text-danger">{{ errors.postalTown }}</small>
                      </div>

                      <!-- Physical Address -->
                      <div class="col-md-6 col-lg-8 mb-3">
                        <label class="form-label">
                          Physical Address <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-home-map-marker"></i></span>
                          <input
                              v-model="employee.physicalAddress"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.physicalAddress}"
                              placeholder="Enter Address details"
                              @blur="validateField('physicalAddress')"
                          >
                        </div>
                        <small v-if="errors.physicalAddress" class="text-danger">{{ errors.physicalAddress }}</small>
                      </div>
                    </div>

                    <!-- Employment Information -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-briefcase me-2"></i>
                            Employment Information (Required)
                          </h6>
                        </div>
                      </div>

                      <!-- Department -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Department <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-office-building"></i></span>
                          <select
                              v-model="employee.departmentID"
                              class="form-select"
                              :class="{'is-invalid': errors.departmentID}"
                              @change="onDepartmentChange"
                          >
                            <option value="">Select Department</option>
                            <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                              {{ dept.departmentName }}
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.departmentID" class="text-danger">{{ errors.departmentID }}</small>
                      </div>

                      <!-- Section / Sub-vote -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Section / Sub-vote <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-view-list"></i></span>
                          <select
                              v-model="employee.sectionId"
                              class="form-select"
                              :class="{'is-invalid': errors.sectionId}"
                              @change="onSectionChange"
                              :disabled="!employee.departmentID"
                          >
                            <option value="">Select Section/Sub-vote</option>
                            <option v-for="sec in sections" :key="sec.id" :value="sec.id">
                              {{ sec.name }} <span v-if="sec.sub_vote_code">({{ sec.sub_vote_code }})</span>
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.sectionId" class="text-danger">{{ errors.sectionId }}</small>
                      </div>

                      <!-- Unit / Directorate (Sub Head) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Unit / Directorate (Sub Head) <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-view-grid-plus"></i></span>
                          <select
                              v-model="employee.unitId"
                              class="form-select"
                              :class="{'is-invalid': errors.unitId}"
                              @change="onUnitChange"
                              :disabled="!employee.sectionId"
                          >
                            <option value="">Select Unit/Directorate</option>
                            <option v-for="unit in units" :key="unit.id" :value="unit.id">
                              {{ unit.name }}
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.unitId" class="text-danger">{{ errors.unitId }}</small>
                      </div>

                      <!-- Sub Unit -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Sub Unit <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-view-module"></i></span>
                          <select
                              v-model="employee.subUnitId"
                              class="form-select"
                              :class="{'is-invalid': errors.subUnitId}"
                              @change="validateField('subUnitId')"
                              :disabled="!employee.unitId"
                          >
                            <option value="">Select Sub Unit</option>
                            <option v-for="su in subUnits" :key="su.id" :value="su.id">
                              {{ su.name }}
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.subUnitId" class="text-danger">{{ errors.subUnitId }}</small>
                      </div>

                      <!-- Designation (Position) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Designation <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-briefcase-account"></i></span>
                          <select
                              v-model="employee.positionId"
                              class="form-select"
                              :class="{'is-invalid': errors.positionId}"
                              @change="handlePositionChange"
                          >
                            <option value="">Select Designation</option>
                            <option v-for="pos in positions" :key="pos.id" :value="pos.id">
                              {{ pos.positionName }} ({{ pos.code }})
                              <span v-if="pos.level">- Level {{ pos.level }}</span>
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.positionId" class="text-danger">{{ errors.positionId }}</small>
                        <small v-else-if="selectedPosition" class="text-info">
                          {{ selectedPosition.description }}
                        </small>
                      </div>
                      
                      <!-- Job Group (select) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Job Group <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-tag-multiple"></i></span>
                          <select
                              v-model="employee.jobGroup"
                              class="form-select"
                              :class="{'is-invalid': errors.jobGroup}"
                              @change="validateField('jobGroup')"
                          >
                            <option value="">Select Job Group</option>
                            <option v-for="jg in jobGroups" :key="jg.id" :value="jg.name">
                              {{ jg.code }} - {{ jg.name }}
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.jobGroup" class="text-danger">{{ errors.jobGroup }}</small>
                      </div>

                      <!-- Employment Type -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Employment Type <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-badge-account"></i></span>
                          <select
                              v-model="employee.employmentType"
                              class="form-select"
                              :class="{'is-invalid': errors.employmentType}"
                              @change="validateField('employmentType')"
                          >
                            <option value="">Select Type</option>
                            <option v-for="t in employmentTypes" :key="t.id || t.code || t.name" :value="t.name">
                              {{ t.name }}
                            </option>
                          </select>
                        </div>
                        <small v-if="errors.employmentType" class="text-danger">{{ errors.employmentType }}</small>
                      </div>

                      <!-- Employment Date -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Employment Date <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-calendar-check"></i></span>
                          <input
                              v-model="employee.hireDate"
                              type="date"
                              class="form-control"
                              :class="{'is-invalid': errors.hireDate}"
                              @blur="validateField('hireDate')"
                          >
                        </div>
                        <small v-if="errors.hireDate" class="text-danger">{{ errors.hireDate }}</small>
                      </div>
                      
                      <!-- Supervisor (Position) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Supervisor (Position)
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-tie"></i></span>
                          <select
                              v-model="employee.supervisorPositionId"
                              class="form-select"
                              :disabled="!positions.length"
                          >
                            <option value="">Select supervisor position</option>
                            <option v-for="pos in positions" :key="pos.id" :value="pos.id">
                              {{ pos.positionName }} ({{ pos.code }})
                              <span v-if="pos.level"> – Level {{ pos.level }}</span>
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Net Salary -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Net Salary
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-cash"></i></span>
                          <input
                              v-model="employee.netSalary"
                              type="number"
                              min="0"
                              class="form-control"
                              placeholder="Enter Amount"
                          >
                        </div>
                      </div>

                      <!-- KRA PIN -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          KRA PIN
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-card-account-details-outline"></i></span>
                          <input
                              v-model="employee.kraPin"
                              type="text"
                              class="form-control"
                              placeholder="Enter KRA PIN"
                          >
                        </div>
                      </div>

                      <!-- SHIF Number (Employment Details) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          SHIF Number
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-card-account-details-outline"></i></span>
                          <input
                              v-model="employee.shifNumber"
                              type="text"
                              class="form-control"
                              placeholder="Enter SHIF Number"
                          >
                        </div>
                      </div>

                      <!-- NSSF Number (Employment Details) -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          NSSF Number
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-card-account-details-outline"></i></span>
                          <input
                              v-model="employee.nssfNumber"
                              type="text"
                              class="form-control"
                              placeholder="Enter NSSF Number"
                          >
                        </div>
                      </div>

                      <!-- Nationality -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Nationality <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-flag"></i></span>
                          <select
                              v-model="employee.nationality"
                              class="form-select"
                              :class="{'is-invalid': errors.nationality}"
                              @change="validateField('nationality')"
                          >
                            <option value="">Select Country</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Rwanda">Rwanda</option>
                            <option value="Burundi">Burundi</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Somalia">Somalia</option>
                            <option value="South Sudan">South Sudan</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Democratic Republic of Congo">Democratic Republic of Congo</option>
                            <option value="South Africa">South Africa</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Egypt">Egypt</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Algeria">Algeria</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Libya">Libya</option>
                            <option value="Cameroon">Cameroon</option>
                            <option value="Zimbabwe">Zimbabwe</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Malawi">Malawi</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Angola">Angola</option>
                            <option value="United States">United States</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="Canada">Canada</option>
                            <option value="Australia">Australia</option>
                            <option value="India">India</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="China">China</option>
                            <option value="Japan">Japan</option>
                            <option value="South Korea">South Korea</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Vietnam">Vietnam</option>
                            <option value="Germany">Germany</option>
                            <option value="France">France</option>
                            <option value="Italy">Italy</option>
                            <option value="Spain">Spain</option>
                            <option value="Netherlands">Netherlands</option>
                            <option value="Belgium">Belgium</option>
                            <option value="Switzerland">Switzerland</option>
                            <option value="Austria">Austria</option>
                            <option value="Sweden">Sweden</option>
                            <option value="Norway">Norway</option>
                            <option value="Denmark">Denmark</option>
                            <option value="Finland">Finland</option>
                            <option value="Poland">Poland</option>
                            <option value="Russia">Russia</option>
                            <option value="Ukraine">Ukraine</option>
                            <option value="Brazil">Brazil</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Argentina">Argentina</option>
                            <option value="Chile">Chile</option>
                            <option value="Colombia">Colombia</option>
                            <option value="Peru">Peru</option>
                            <option value="Venezuela">Venezuela</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="United Arab Emirates">United Arab Emirates</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Kuwait">Kuwait</option>
                            <option value="Israel">Israel</option>
                            <option value="Turkey">Turkey</option>
                            <option value="Iran">Iran</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        <small v-if="errors.nationality" class="text-danger">{{ errors.nationality }}</small>
                      </div>

                      <!-- Gender -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Gender <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-gender-male-female"></i></span>
                          <select
                              v-model="employee.gender"
                              class="form-select"
                              :class="{'is-invalid': errors.gender}"
                              @change="validateField('gender')"
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        <small v-if="errors.gender" class="text-danger">{{ errors.gender }}</small>
                      </div>

                      <!-- Date of Birth -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Date of Birth <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-calendar"></i></span>
                          <input
                              v-model="employee.dateOfBirth"
                              type="date"
                              class="form-control"
                              :class="{'is-invalid': errors.dateOfBirth}"
                              :max="maxDate"
                              @change="calculateAge()"
                              @blur="validateField('dateOfBirth')"
                          >
                        </div>
                        <small v-if="errors.dateOfBirth" class="text-danger">{{ errors.dateOfBirth }}</small>
                      </div>

                      <!-- Age -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Age <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-calendar-account"></i></span>
                          <input
                              v-model="employee.age"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.age}"
                              placeholder="Auto-calculated from DOB"
                              readonly
                              @blur="validateField('age')"
                          >
                        </div>
                        <small v-if="errors.age" class="text-danger">{{ errors.age }}</small>
                      </div>
                    </div>

                    <!-- Extra Employment & Personal Details -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-card-account-details-star-outline me-2"></i>
                            Extra Details
                          </h6>
                        </div>
                      </div>

                      <!-- Education Level -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Education Level <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-school"></i></span>
                          <select
                              v-model="employee.educationLevel"
                              class="form-select"
                              :class="{'is-invalid': errors.educationLevel}"
                              @change="validateField('educationLevel')"
                          >
                            <option value="">Select Education Level</option>
                            <option value="Primary">Primary</option>
                            <option value="Secondary">Secondary</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Degree">Degree</option>
                            <option value="Masters">Masters</option>
                            <option value="Doctorate">Doctorate</option>
                          </select>
                        </div>
                        <small v-if="errors.educationLevel" class="text-danger">{{ errors.educationLevel }}</small>
                      </div>

                      <!-- Sub County -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          County <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-map-marker"></i></span>
                          <input
                              v-model="employee.county"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.county}"
                              placeholder="Enter County"
                              @blur="validateField('county')"
                          >
                        </div>
                        <small v-if="errors.county" class="text-danger">{{ errors.county }}</small>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Sub County <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-map-marker-radius"></i></span>
                          <input
                              v-model="employee.subCounty"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.subCounty}"
                              placeholder="Select Sub County"
                              @blur="validateField('subCounty')"
                          >
                        </div>
                        <small v-if="errors.subCounty" class="text-danger">{{ errors.subCounty }}</small>
                      </div>

                      <!-- Ward -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Ward <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-map-marker"></i></span>
                          <input
                              v-model="employee.ward"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.ward}"
                              placeholder="Select Ward"
                              @blur="validateField('ward')"
                          >
                        </div>
                        <small v-if="errors.ward" class="text-danger">{{ errors.ward }}</small>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Ethnicity <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-group"></i></span>
                          <input
                              v-model="employee.ethnicity"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': errors.ethnicity}"
                              placeholder="Enter Ethnicity"
                              @blur="validateField('ethnicity')"
                          >
                        </div>
                        <small v-if="errors.ethnicity" class="text-danger">{{ errors.ethnicity }}</small>
                      </div>

                      <!-- Marital Status -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Marital Status <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-multiple"></i></span>
                          <select
                              v-model="employee.maritalStatus"
                              class="form-select"
                              :class="{'is-invalid': errors.maritalStatus}"
                              @change="validateField('maritalStatus')"
                          >
                            <option value="">Select Marital Status</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                          </select>
                        </div>
                        <small v-if="errors.maritalStatus" class="text-danger">{{ errors.maritalStatus }}</small>
                      </div>

                      <!-- Driving License -->
                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Driving License
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-steering"></i></span>
                          <input
                              v-model="employee.drivingLicense"
                              type="text"
                              class="form-control"
                              placeholder="Enter Driving License Number"
                          >
                        </div>
                      </div>

                      <!-- Spouse Name -->
                      <div class="col-md-6 col-lg-6 mb-3">
                        <label class="form-label">
                          Spouse Name
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-heart"></i></span>
                          <input
                              v-model="employee.spouseName"
                              type="text"
                              class="form-control"
                              placeholder="Enter Spouse Name"
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Bank Details (Optional) -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-bank me-2"></i>
                            Bank Details (Optional)
                          </h6>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Account Holder Name
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-account-card-details-outline"></i></span>
                          <input
                              v-model="employee.accountHolder"
                              type="text"
                              class="form-control"
                              placeholder="Enter Account Holder Name"
                          >
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Account Number
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-numeric"></i></span>
                          <input
                              v-model="employee.accountNumber"
                              type="text"
                              class="form-control"
                              placeholder="Enter Account Number"
                          >
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Bank Country
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-earth"></i></span>
                          <input
                              v-model="employee.bankCountry"
                              type="text"
                              class="form-control"
                              placeholder="Enter Bank Country"
                          >
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Bank Name
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-bank-outline"></i></span>
                          <input
                              v-model="employee.bankName"
                              type="text"
                              class="form-control"
                              placeholder="Enter Bank Name"
                          >
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 mb-3">
                        <label class="form-label">
                          Branch / Location
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-map-marker-outline"></i></span>
                          <input
                              v-model="employee.branchLocation"
                              type="text"
                              class="form-control"
                              placeholder="Enter Branch Location"
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Documents Upload (Government ID / Education / Other) -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-file-multiple-outline me-2"></i>
                            Documents (Upload now or later)
                          </h6>
                          <small class="text-muted">
                            Upload supporting documents grouped as Government ID, Education, and Other documents. You can add more after approval from the employee profile.
                          </small>
                        </div>
                      </div>

                      <div class="col-12 d-flex justify-content-end mb-3">
                        <button type="button" class="btn btn-outline-primary btn-sm" @click="addDocument">
                          <i class="mdi mdi-plus-circle-outline me-1"></i>
                          Add Document
                        </button>
                      </div>

                      <div class="col-12" v-if="documents.length === 0">
                        <div class="text-center text-muted py-3">
                          <i class="mdi mdi-file-document-outline" style="font-size: 32px;"></i>
                          <p class="mb-0">No documents added yet</p>
                        </div>
                      </div>

                      <div class="col-12" v-else>
                        <div
                          v-for="(doc, index) in documents"
                          :key="index"
                          class="border rounded p-3 mb-3"
                        >
                          <div class="row">
                            <div class="col-md-3 mb-3">
                              <label class="form-label">Document Type <span class="text-danger">*</span></label>
                              <select
                                v-model="doc.documentType"
                                class="form-select"
                                :class="{'is-invalid': doc.errors?.documentType}"
                                @change="onDocumentTypeChange(index, $event)"
                              >
                                <option value="">Select Type</option>
                                <option
                                  v-for="docType in documentTypes"
                                  :key="docType.id"
                                  :value="docType.type_name"
                                >
                                  {{ docType.type_name }}
                                  <span v-if="docType.category"> ({{ docType.category }})</span>
                                </option>
                              </select>
                              <small v-if="doc.errors?.documentType" class="text-danger">{{ doc.errors.documentType }}</small>
                            </div>

                            <div class="col-md-3 mb-3">
                              <label class="form-label">Document Name <span class="text-danger">*</span></label>
                              <input
                                v-model="doc.name"
                                type="text"
                                class="form-control"
                                :class="{'is-invalid': doc.errors?.name}"
                                placeholder="e.g., National ID copy"
                              >
                              <small v-if="doc.errors?.name" class="text-danger">{{ doc.errors.name }}</small>
                            </div>

                            <div class="col-md-3 mb-3">
                              <label class="form-label">Document Number</label>
                              <input
                                v-model="doc.documentNumber"
                                type="text"
                                class="form-control"
                                placeholder="Certificate / ID number"
                              >
                            </div>

                            <div class="col-md-3 mb-3">
                              <label class="form-label">Valid Until</label>
                              <input
                                v-model="doc.validTill"
                                type="date"
                                class="form-control"
                              >
                            </div>

                            <div class="col-md-6 mb-3">
                              <label class="form-label">Upload File</label>
                              <input
                                type="file"
                                class="form-control"
                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                @change="onDocumentFileChange(index, $event)"
                                :disabled="doc.uploading"
                              >
                              <small class="text-muted">PDF, JPG, PNG, DOC, DOCX. Max 5MB.</small>

                              <div v-if="doc.uploading" class="mt-2 d-flex align-items-center">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                <small class="text-primary">Uploading...</small>
                              </div>

                              <div v-if="doc.filePath && !doc.uploading" class="mt-2 alert alert-success py-2 mb-0">
                                <i class="mdi mdi-check-circle-outline me-1"></i>
                                <small>{{ doc.originalFileName || doc.name }} uploaded</small>
                              </div>
                            </div>

                            <div class="col-md-6 mb-3 d-flex align-items-end justify-content-end">
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                @click="removeDocument(index)"
                              >
                                <i class="mdi mdi-delete-outline me-1"></i>
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Emergency Contacts & Next of Kin (Optional) -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="bg-light p-3 mb-3 rounded">
                          <h6 class="mb-0 text-primary">
                            <i class="mdi mdi-phone-alert-outline me-2"></i>
                            Emergency Contacts & Next of Kin
                          </h6>
                          <small class="text-muted">
                            You can capture contact persons now or update them later in Edit Employee.
                          </small>
                        </div>
                      </div>

                      <!-- Emergency Contacts -->
                      <div class="col-12 mb-3">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <h6 class="mb-0">Emergency Contacts</h6>
                          <button type="button" class="btn btn-outline-primary btn-sm" @click="addEmergencyContact">
                            <i class="mdi mdi-plus-circle-outline me-1"></i>
                            Add Emergency Contact
                          </button>
                        </div>

                        <div v-if="emergencyContacts.length === 0" class="text-muted small mb-3">
                          No emergency contacts added yet.
                        </div>

                        <div
                          v-for="(contact, index) in emergencyContacts"
                          :key="'ec-' + index"
                          class="border rounded p-3 mb-2"
                        >
                          <div class="row">
                            <div class="col-md-4 mb-2">
                              <label class="form-label">Full Name</label>
                              <input
                                v-model="contact.name"
                                type="text"
                                class="form-control"
                                placeholder="Contact person name"
                              >
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="form-label">Phone Number</label>
                              <input
                                v-model="contact.phoneNumber"
                                type="tel"
                                class="form-control"
                                placeholder="07XXXXXXXX"
                              >
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="form-label">Relationship</label>
                              <select v-model="contact.relationship" class="form-select">
                                <option value="">Select Relationship</option>
                                <option
                                  v-for="relType in relationshipTypes"
                                  :key="relType.id"
                                  :value="relType.relationship_name"
                                >
                                  {{ relType.relationship_name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-8 mb-2">
                              <label class="form-label">Email (optional)</label>
                              <input
                                v-model="contact.email"
                                type="email"
                                class="form-control"
                                placeholder="contact@example.com"
                              >
                            </div>
                            <div class="col-md-4 mb-2 d-flex align-items-end justify-content-end">
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                @click="removeEmergencyContact(index)"
                              >
                                <i class="mdi mdi-delete-outline me-1"></i>
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Next of Kin -->
                      <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <h6 class="mb-0">Next of Kin</h6>
                          <button type="button" class="btn btn-outline-primary btn-sm" @click="addNextOfKin">
                            <i class="mdi mdi-plus-circle-outline me-1"></i>
                            Add Next of Kin
                          </button>
                        </div>

                        <div v-if="nextOfKin.length === 0" class="text-muted small mb-3">
                          No next of kin added yet.
                        </div>

                        <div
                          v-for="(kin, index) in nextOfKin"
                          :key="'kin-' + index"
                          class="border rounded p-3 mb-2"
                        >
                          <div class="row">
                            <div class="col-md-3 mb-2">
                              <label class="form-label">Full Name</label>
                              <input
                                v-model="kin.name"
                                type="text"
                                class="form-control"
                                placeholder="Next of kin name"
                              >
                            </div>
                            <div class="col-md-3 mb-2">
                              <label class="form-label">Phone Number</label>
                              <input
                                v-model="kin.phoneNumber"
                                type="tel"
                                class="form-control"
                                placeholder="07XXXXXXXX"
                              >
                            </div>
                            <div class="col-md-3 mb-2">
                              <label class="form-label">Relationship</label>
                              <select v-model="kin.relationship" class="form-select">
                                <option value="">Select Relationship</option>
                                <option
                                  v-for="relType in relationshipTypes"
                                  :key="relType.id"
                                  :value="relType.relationship_name"
                                >
                                  {{ relType.relationship_name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-3 mb-2">
                              <label class="form-label">Email (optional)</label>
                              <input
                                v-model="kin.email"
                                type="email"
                                class="form-control"
                                placeholder="kin@example.com"
                              >
                            </div>
                            <div class="col-md-8 mb-2">
                              <div class="form-check">
                                <input
                                  v-model="kin.isCoveredInBenefits"
                                  class="form-check-input"
                                  type="checkbox"
                                  :id="`benefits-create-${index}`"
                                >
                                <label class="form-check-label" :for="`benefits-create-${index}`">
                                  Include in benefits coverage (medical, insurance, etc.)
                                </label>
                              </div>
                            </div>
                            <div class="col-md-4 mb-2 d-flex align-items-end justify-content-end">
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                @click="removeNextOfKin(index)"
                              >
                                <i class="mdi mdi-delete-outline me-1"></i>
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Position Details (shown when position selected) -->
                  <div v-if="selectedPosition" class="row mb-4">
                    <div class="col-12">
                      <div class="bg-light p-3 rounded">
                        <h6 class="mb-3 text-primary">
                          <i class="mdi mdi-information me-2"></i>
                          Position Details
                        </h6>
                        <div class="row">
                          <div class="col-md-3">
                            <small class="text-muted d-block">Position Code</small>
                            <strong>{{ selectedPosition.code }}</strong>
                          </div>
                          <div class="col-md-3">
                            <small class="text-muted d-block">Level</small>
                            <strong>{{ selectedPosition.level || 'N/A' }}</strong>
                          </div>
                          <div class="col-md-3">
                            <small class="text-muted d-block">Salary Range</small>
                            <strong>
                              {{ formatSalary(selectedPosition.salary_min) }} - 
                              {{ formatSalary(selectedPosition.salary_max) }}
                            </strong>
                          </div>
                          <div class="col-md-3">
                            <small class="text-muted d-block">Supervisor</small>
                            <strong>{{ selectedPosition.reports_to_name || 'N/A' }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Action Buttons -->
                  <div class="row mt-4">
                    <div class="col-12">
                      <hr>
                      <div class="d-flex justify-content-between">
                        <button
                            type="button"
                            @click="resetForm"
                            class="btn btn-outline-secondary"
                        >
                          <i class="mdi mdi-refresh me-2"></i>
                          Reset Form
                        </button>
                        <div>
                          <button
                              type="button"
                              @click="validateAndSubmit"
                              class="btn btn-primary"
                              :disabled="loading"
                          >
                            <span v-if="!loading">
                              <i class="mdi mdi-check me-2"></i>
                              Submit for Approval
                            </span>
                            <span v-else>
                              <span class="spinner-border spinner-border-sm me-2"></span>
                              Submitting...
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Success Modal (Vue-controlled, no Bootstrap) -->
    <div v-if="showSuccessModal" class="modal-overlay" @click.self="showSuccessModal = false">
      <div class="modal-dialog-custom">
        <div class="modal-content-custom">
          <div class="modal-body-custom text-center p-5">
            <div class="mb-4">
              <div class="avatar-lg mx-auto">
                <div class="avatar-title bg-light text-success rounded-circle">
                  <i class="bx bx-check-circle font-size-48"></i>
                </div>
              </div>
            </div>
            <h4 class="mb-3">Employee Created Successfully!</h4>
            <p class="text-muted mb-4">{{ successMessage }}</p>
            <div class="d-grid gap-2">
              <button type="button" @click="showSuccessModal = false; gotTo('employee-register')" class="btn btn-primary">
                <i class="bx bx-list-ul me-2"></i> View All Employees
              </button>
              <button type="button" @click="createAnotherAndCloseModal" class="btn btn-outline-primary">
                <i class="bx bx-plus me-2"></i> Add Another Employee
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal (Vue-controlled, no Bootstrap) -->
    <div v-if="showErrorModal" class="modal-overlay" @click.self="showErrorModal = false">
      <div class="modal-dialog-custom">
        <div class="modal-content-custom">
          <div class="modal-body-custom text-center p-5">
            <div class="mb-4">
              <div class="avatar-lg mx-auto">
                <div class="avatar-title bg-light text-danger rounded-circle">
                  <i class="bx bx-error-circle font-size-48"></i>
                </div>
              </div>
            </div>
            <h4 class="mb-3">Error Creating Employee</h4>
            <p class="text-muted mb-4">{{ errorMessage }}</p>
            <button type="button" @click="showErrorModal = false" class="btn btn-danger">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import { authUrl, execute } from "@/api";

export default {
  name: "EmployeeCreateSimplified",
  components: { NavigationBar },
  data() {
    return {
      // Form Data
      employee: {
        title: '',
        empNo: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        personalEmail: '',
        phone: '',
        nationalId: '',
        gender: '',
        dateOfBirth: '',
        nationality: 'Kenya',
        employmentType: '',
        hireDate: '',
        age: '',
        ethnicity: '',
        county: '',
        disabilityStatus: '',
        disabilityId: '',
        postalCode: '',
        postalTown: '',
        physicalAddress: '',
        educationLevel: '',
        subCounty: '',
        ward: '',
        maritalStatus: '',
        drivingLicense: '',
        spouseName: '',
        sectionId: '',
        unitId: '',
        subUnitId: '',
        departmentID: '',
        departmentName: '',
        positionId: '', // NEW
        positionTitle: '', // NEW - will be filled from selected position
        jobGroup: '', // NEW - job group from position
        supervisorPositionId: '', // supervisor = position, not employee
        reportingTo: '',
        netSalary: '',
        kraPin: '',
        accountHolder: '',
        accountNumber: '',
        bankCountry: '',
        bankName: '',
        branchLocation: '',
        shifNumber: '',
        nssfNumber: ''
      },

      // UI State
      loading: false,
      departments: [],
      positions: [], // NEW
      selectedPosition: null, // NEW
      employmentTypes: [],
      jobGroups: [],
      sections: [],
      units: [],
      subUnits: [],

      // Dynamic arrays
      documents: [],
      emergencyContacts: [],
      nextOfKin: [],

      // Dropdown data
      documentTypes: [],
      relationshipTypes: [],

      // Validation
      errors: {},

      // Messages
      successMessage: '',
      errorMessage: '',
      showSuccessModal: false,
      showErrorModal: false,

      // Computed max date for DOB (18 years ago)
      maxDate: ''
    };
  },

  computed: {
    requiresPersonalEmail() {
      const selected = String(this.employee.employmentType || '').trim().toLowerCase();
      if (!selected) return false;
      const cfg = (this.employmentTypes || []).find((t) => String(t.name || '').trim().toLowerCase() === selected);
      if (cfg) return String(cfg.requires_personal_email || '').trim().toLowerCase() === 'yes';
      return ['contract', 'consultant', 'intern'].includes(selected);
    }
  },

  mounted() {
    this.loadDepartments();
    this.loadPositions(); // NEW
    this.loadEmploymentTypes();
    this.loadJobGroups();
    this.loadDocumentTypes();
    this.loadRelationshipTypes();
    this.setMaxDate();
  },

  methods: {
    setMaxDate() {
      const today = new Date();
      const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      this.maxDate = eighteenYearsAgo.toISOString().split('T')[0];
    },

    async loadDepartments() {
      try {
        const data = new FormData();
        data.append("function", "getDepartments");

        const res = await execute(data, authUrl);

        if (res && res.data && res.data.success) {
          this.departments = res.data.data?.departments || res.data.departments || [];
        } else {
          console.warn("Failed to load departments");
          this.departments = [];
        }
      } catch (error) {
        console.error("Error loading departments:", error);
        this.departments = [];
      }
    },

    // Load sections when department changes
    async loadSections() {
      if (!this.employee.departmentID) {
        this.sections = [];
        this.units = [];
        this.subUnits = [];
        return;
      }
      try {
        const data = new FormData();
        data.append("function", "getSectionsByDepartment");
        data.append("departmentId", this.employee.departmentID);
        const res = await execute(data, authUrl);
        this.sections = res?.data?.data?.sections || res?.data?.sections || [];
      } catch (e) {
        console.error("Error loading sections:", e);
        this.sections = [];
      }
    },

    async loadUnits() {
      if (!this.employee.sectionId) {
        this.units = [];
        this.subUnits = [];
        return;
      }
      try {
        const data = new FormData();
        data.append("function", "getUnitsBySection");
        data.append("sectionId", this.employee.sectionId);
        const res = await execute(data, authUrl);
        this.units = res?.data?.data?.units || res?.data?.units || [];
      } catch (e) {
        console.error("Error loading units:", e);
        this.units = [];
      }
    },

    async loadSubUnits() {
      if (!this.employee.unitId) {
        this.subUnits = [];
        return;
      }
      try {
        const data = new FormData();
        data.append("function", "getSubUnitsByUnit");
        data.append("unitId", this.employee.unitId);
        const res = await execute(data, authUrl);
        this.subUnits = res?.data?.data?.subUnits || res?.data?.subUnits || [];
      } catch (e) {
        console.error("Error loading sub units:", e);
        this.subUnits = [];
      }
    },

    async loadDocumentTypes() {
      try {
        const data = new FormData();
        data.append("function", "getDocumentTypes");
        const res = await execute(data, authUrl);
        this.documentTypes = res?.data?.data?.documentTypes || res?.data?.documentTypes || [];
      } catch (e) {
        console.error("Error loading document types:", e);
        this.documentTypes = [];
      }
    },

    async loadRelationshipTypes() {
      try {
        const data = new FormData();
        data.append("function", "getRelationshipTypes");
        const res = await execute(data, authUrl);
        this.relationshipTypes = res?.data?.data?.relationshipTypes || res?.data?.relationshipTypes || [];
      } catch (e) {
        console.error("Error loading relationship types:", e);
        this.relationshipTypes = [];
      }
    },

    // NEW: Load positions
    async loadPositions() {
      try {
        const data = new FormData();
        data.append("function", "getAllPositions");

        const res = await execute(data, authUrl);

        if (res && res.data && res.data.success) {
          this.positions = res.data.data?.positions || res.data.positions || [];
        } else {
          console.warn("Failed to load positions");
          this.positions = [];
        }
      } catch (error) {
        console.error("Error loading positions:", error);
        this.positions = [];
      }
    },
    async loadEmploymentTypes() {
      try {
        const data = new FormData();
        data.append("function", "getEmploymentTypes");
        const res = await execute(data, authUrl);
        const rows = res?.data?.data?.employmentTypes || res?.data?.data?.data || [];
        this.employmentTypes = Array.isArray(rows) ? rows : [];
      } catch (error) {
        console.error("Error loading employment types:", error);
        this.employmentTypes = [];
      }
    },

    async loadJobGroups() {
      try {
        const data = new FormData();
        data.append("function", "getJobGroups");
        const res = await execute(data, authUrl);
        if (res && res.data && res.data.success) {
          let raw = res.data.data?.jobGroups ?? res.data.jobGroups ?? [];
          if (raw && raw.Records) raw = raw.Records;
          if (!Array.isArray(raw) && raw) raw = [raw];
          this.jobGroups = raw || [];
        } else {
          this.jobGroups = [];
        }
      } catch (error) {
        console.error("Error loading job groups:", error);
        this.jobGroups = [];
      }
    },

    // NEW: Handle position selection
    handlePositionChange() {
      this.validateField('positionId');
      
      if (this.employee.positionId) {
        this.selectedPosition = this.positions.find(p => p.id === this.employee.positionId);
        if (this.selectedPosition) {
          this.employee.positionTitle = this.selectedPosition.positionName;
          // Optional: Auto-fill department if position has department
          if (this.selectedPosition.department_id && !this.employee.departmentID) {
            this.employee.departmentID = this.selectedPosition.department_id;
          }
        }
      } else {
        this.selectedPosition = null;
        this.employee.positionTitle = '';
      }
    },

    // Format salary
    formatSalary(salary) {
      if (!salary || salary === 0) return 'N/A';
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(salary);
    },

    validateField(field) {
      // Clear previous error for this field
      delete this.errors[field];

      if (field === 'empNo' && !this.employee.empNo) {
        this.errors[field] = 'Employee number is required';
      }

      // Name validations
      if (field === 'firstName' && !this.employee.firstName) {
        this.errors[field] = 'First name is required';
      }

      if (field === 'lastName' && !this.employee.lastName) {
        this.errors[field] = 'Last name is required';
      }

      // Email validation
      if (field === 'email') {
        if (!this.employee.email) {
          this.errors[field] = 'Email is required';
        } else if (!this.isValidEmail(this.employee.email)) {
          this.errors[field] = 'Please enter a valid email address';
        }
      }

      // Phone validation (optional, but must be valid if provided)
      if (field === 'phone' && this.employee.phone) {
        if (!this.isValidPhone(this.employee.phone)) {
          this.errors[field] = 'Please enter a valid phone number';
        }
      }

      // National ID validation
      if (field === 'nationalId' && !this.employee.nationalId) {
        this.errors[field] = 'National ID is required';
      }

      // Disability status (PWD)
      if (field === 'disabilityStatus' && !this.employee.disabilityStatus) {
        this.errors[field] = 'PWD status is required';
      }

      // Gender validation
      if (field === 'gender' && !this.employee.gender) {
        this.errors[field] = 'Gender is required';
      }

      // Date of Birth validation
      if (field === 'dateOfBirth' && !this.employee.dateOfBirth) {
        this.errors[field] = 'Date of birth is required';
      }
      if (field === 'dateOfBirth' && this.employee.dateOfBirth) {
        this.calculateAge();
      }
      if (field === 'age') {
        if (!this.employee.age || Number(this.employee.age) <= 0) {
          this.errors[field] = 'Age is required';
        }
      }

      // Hire Date validation
      if (field === 'hireDate' && !this.employee.hireDate) {
        this.errors[field] = 'Date of employment is required';
      }

      // Department validation
      if (field === 'departmentID' && !this.employee.departmentID) {
        this.errors[field] = 'Department is required';
      }

      // Designation validation
      if (field === 'positionId' && !this.employee.positionId) {
        this.errors[field] = 'Designation is required';
      }

      // Job group validation
      if (field === 'jobGroup' && !this.employee.jobGroup) {
        this.errors[field] = 'Job group is required';
      }

      // Employment Type validation
      if (field === 'employmentType' && !this.employee.employmentType) {
        this.errors[field] = 'Employment type is required';
      }

      // Education level
      if (field === 'educationLevel' && !this.employee.educationLevel) {
        this.errors[field] = 'Highest academic qualification is required';
      }

      // Location
      if (field === 'county' && !this.employee.county) {
        this.errors[field] = 'County is required';
      }
      if (field === 'subCounty' && !this.employee.subCounty) {
        this.errors[field] = 'Sub county is required';
      }
      if (field === 'ward' && !this.employee.ward) {
        this.errors[field] = 'Ward is required';
      }
      if (field === 'ethnicity' && !this.employee.ethnicity) {
        this.errors[field] = 'Ethnicity is required';
      }

      // Personal Email (mandatory for Contract/Consultant/Intern)
      if (field === 'personalEmail' && this.requiresPersonalEmail) {
        if (!this.employee.personalEmail) {
          this.errors[field] = 'Personal email is required for ' + (this.employee.employmentType || '');
        } else if (!this.isValidEmail(this.employee.personalEmail)) {
          this.errors[field] = 'Please enter a valid personal email address';
        }
      }

      // Force reactivity update
      this.errors = { ...this.errors };
    },

    validateAllFields() {
      // Validate all mandatory fields including position
      this.validateField('empNo');
      this.validateField('firstName');
      this.validateField('lastName');
      this.validateField('email');
      this.validateField('nationalId');
      this.validateField('gender');
      this.validateField('dateOfBirth');
      this.validateField('age');
      this.validateField('hireDate');
      this.validateField('departmentID');
      this.validateField('positionId'); // NEW
      this.validateField('jobGroup');
      this.validateField('employmentType');
      this.validateField('personalEmail');
      this.validateField('disabilityStatus');
      this.validateField('educationLevel');
      this.validateField('county');
      this.validateField('subCounty');
      this.validateField('ward');
      this.validateField('ethnicity');

      return Object.keys(this.errors).length === 0;
    },

    isValidEmail(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },

    isValidPhone(phone) {
      const re = /^[\d\s\-\+\(\)]+$/;
      return re.test(phone) && phone.replace(/\D/g, '').length >= 9;
    },

    calculateAge() {
      if (!this.employee.dateOfBirth) {
        this.employee.age = '';
        return;
      }
      const dob = new Date(this.employee.dateOfBirth);
      if (isNaN(dob.getTime())) {
        this.employee.age = '';
        return;
      }
      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
      this.employee.age = age > 0 ? String(age) : '';
    },

    async validateAndSubmit() {
      if (!this.validateAllFields()) {
        this.$toast?.error("Please fill in all required fields correctly") ||
        alert("Please fill in all required fields correctly");
        return;
      }

      await this.createEmployee();
    },

    async createEmployee() {
      this.loading = true;

      try {
        // Get department name
        const selectedDept = this.departments.find(d => d.id === this.employee.departmentID);
        if (selectedDept) {
          this.employee.departmentName = selectedDept.departmentName;
        }

        // Get position title
        if (this.selectedPosition) {
          this.employee.positionTitle = this.selectedPosition.positionName;
        }

        // Set defaults for optional fields
        const baseEmployee = {
          ...this.employee,
          middleName: this.employee.middleName || '',
          gender: this.employee.gender || 'Other',
          dateOfBirth: this.employee.dateOfBirth || '1990-01-01',
          nationality: this.employee.nationality || 'Kenya',
          hireDate: this.employee.hireDate || new Date().toISOString().split('T')[0]
        };

        // Prepare related arrays for approval payload
        const preparedDocuments = this.documents
          .filter(doc => (doc.name || doc.filePath))
          .map(doc => ({
            documentType: doc.documentType || '',
            name: doc.name || '',
            documentNumber: doc.documentNumber || '',
            filePath: doc.filePath || '',
            fileSize: doc.fileSize || '',
            fileType: doc.fileType || '',
            uploadDate: doc.uploadDate || new Date().toISOString().split('T')[0],
            validTill: doc.validTill || ''
          }));

        const preparedEmergencyContacts = this.emergencyContacts
          .filter(c => c.name || c.phoneNumber)
          .map(c => ({
            name: c.name || '',
            phoneNumber: c.phoneNumber || '',
            email: c.email || '',
            relationship: c.relationship || ''
          }));

        const preparedNextOfKin = this.nextOfKin
          .filter(k => k.name || k.phoneNumber)
          .map(k => ({
            name: k.name || '',
            phoneNumber: k.phoneNumber || '',
            email: k.email || '',
            relationship: k.relationship || '',
            isCoveredInBenefits: k.isCoveredInBenefits ? '1' : '0'
          }));

        const bankDetails = {
          accountHolder: this.employee.accountHolder || '',
          accountNumber: this.employee.accountNumber || '',
          bankCountry: this.employee.bankCountry || '',
          bankName: this.employee.bankName || '',
          branchLocation: this.employee.branchLocation || ''
        };

        const supervisorPosition = this.employee.supervisorPositionId
          ? this.positions.find(p => p.id === this.employee.supervisorPositionId)
          : null;
        const reportingToValue = supervisorPosition ? supervisorPosition.positionName : (this.employee.reportingTo || '');
        const employmentDetails = {
          department: this.employee.departmentID || '',
          section: this.employee.sectionId || '',
          unit: this.employee.unitId || '',
          subunit: this.employee.subUnitId || '',
          designation: this.employee.positionTitle || '',
          employmentDate: baseEmployee.hireDate,
          reportingDate: '',
          reportingTo: reportingToValue,
          supervisorPositionId: this.employee.supervisorPositionId || '',
          netSalary: this.employee.netSalary || '0',
          kraPin: this.employee.kraPin || '',
          shifNumber: this.employee.shifNumber || '',
          nssfNumber: this.employee.nssfNumber || '',
          empNo: baseEmployee.empNo || baseEmployee.nationalId
        };

        const extraDetails = {
          employmentType: baseEmployee.employmentType || '',
          educationLevel: baseEmployee.educationLevel || '',
          ethnicity: baseEmployee.ethnicity || '',
          age: baseEmployee.age || '',
          county: baseEmployee.county || '',
          subCounty: baseEmployee.subCounty || '',
          ward: baseEmployee.ward || '',
          maritalStatus: baseEmployee.maritalStatus || '',
          drivingLicense: baseEmployee.drivingLicense || '',
          spouseName: baseEmployee.spouseName || ''
        };

        const employeeData = {
          ...baseEmployee,
          documents: preparedDocuments,
          bankDetails,
          employmentDetails,
          extraDetails,
          emergencyContacts: preparedEmergencyContacts,
          nextOfKin: preparedNextOfKin
        };

        const data = new FormData();
        data.append("function", "submitEmployeeForApproval");
        data.append("employee", JSON.stringify(employeeData));

        const response = await execute(data, authUrl);

        if (response && response.data && response.data.success) {
          this.successMessage = `${employeeData.firstName} ${employeeData.lastName} has been submitted for approval. They will appear in the Employee Register after an approver approves the request (Employee Approvals → Pending Approvals - New Employees).`;
          this.showSuccessModal = true;
        } else {
          throw new Error(response.data?.message || 'Failed to submit for approval');
        }
      } catch (error) {
        console.error('Error creating employee:', error);
        this.errorMessage = error.message || 'An error occurred while creating the employee';
        this.showErrorModal = true;
      } finally {
        this.loading = false;
      }
    },

    onDepartmentChange() {
      this.validateField('departmentID');
      this.employee.sectionId = '';
      this.employee.unitId = '';
      this.employee.subUnitId = '';
      this.sections = [];
      this.units = [];
      this.subUnits = [];
      this.loadSections();
    },

    onSectionChange() {
      this.validateField('sectionId');
      this.employee.unitId = '';
      this.employee.subUnitId = '';
      this.units = [];
      this.subUnits = [];
      this.loadUnits();
    },

    onUnitChange() {
      this.validateField('unitId');
      this.employee.subUnitId = '';
      this.subUnits = [];
      this.loadSubUnits();
    },

    addDocument() {
      this.documents.push({
        documentType: '',
        name: '',
        documentNumber: '',
        filePath: '',
        fileSize: '',
        fileType: '',
        uploadDate: new Date().toISOString().split('T')[0],
        validTill: '',
        uploading: false,
        errors: {}
      });
    },

    removeDocument(index) {
      this.documents.splice(index, 1);
    },

    onDocumentTypeChange(index, event) {
      const selectedType = event.target.value;
      if (selectedType) {
        this.documents[index].name = this.documents[index].name || selectedType;
        this.documents[index].documentType = selectedType;
      } else {
        this.documents[index].documentType = '';
      }
    },

    async onDocumentFileChange(index, event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 5 * 1024 * 1024) {
        this.$toast?.error("File size must be less than 5MB") || alert('File size must be less than 5MB');
        event.target.value = '';
        return;
      }

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        this.$toast?.error("Only PDF, JPG, PNG, DOC, and DOCX files are allowed") ||
        alert('Only PDF, JPG, PNG, DOC, and DOCX files are allowed');
        event.target.value = '';
        return;
      }

      try {
        this.documents[index].uploading = true;

        const formData = new FormData();
        formData.append('function', 'uploadDocument');
        formData.append('file', file);
        formData.append('documentType', this.documents[index].documentType || 'general');
        // For new employees we might not have an ID yet; pass empty so backend just stores file and audit.
        formData.append('employeeId', '');

        const response = await execute(formData, authUrl);

        if (response && response.data && response.data.success) {
          const payload = response.data.data || response.data;
          this.documents[index].filePath = payload.filePath;
          this.documents[index].fileSize = payload.fileSize;
          this.documents[index].fileType = payload.fileType;
          this.documents[index].uploadDate = payload.uploadDate;
          this.documents[index].originalFileName = payload.originalName;

          this.$toast?.success("Document uploaded successfully") ||
          console.log('Document uploaded successfully');
        } else {
          throw new Error(response.data?.message || 'Upload failed');
        }
      } catch (error) {
        console.error('Upload error:', error);
        this.$toast?.error("Failed to upload document: " + error.message) ||
        alert('Failed to upload document: ' + error.message);
        event.target.value = '';

        this.documents[index].filePath = '';
        this.documents[index].fileSize = '';
        this.documents[index].fileType = '';
      } finally {
        this.documents[index].uploading = false;
      }
    },

    addEmergencyContact() {
      this.emergencyContacts.push({
        name: '',
        phoneNumber: '',
        email: '',
        relationship: ''
      });
    },

    removeEmergencyContact(index) {
      this.emergencyContacts.splice(index, 1);
    },

    addNextOfKin() {
      this.nextOfKin.push({
        name: '',
        phoneNumber: '',
        email: '',
        relationship: '',
        isCoveredInBenefits: false
      });
    },

    removeNextOfKin(index) {
      this.nextOfKin.splice(index, 1);
    },

    saveAsDraft() {
      // Store in localStorage for later completion
      const draftData = {
        employee: this.employee,
        savedAt: new Date().toISOString()
      };

      localStorage.setItem('employeeDraft', JSON.stringify(draftData));

      this.$toast?.success("Draft saved successfully!") ||
      alert("Draft saved successfully!");
    },

    loadDraft() {
      const draft = localStorage.getItem('employeeDraft');
      if (draft) {
        const draftData = JSON.parse(draft);
        this.employee = draftData.employee;
        
        // Restore selected position
        if (this.employee.positionId) {
          this.selectedPosition = this.positions.find(p => p.id === this.employee.positionId);
        }

        this.$toast?.info("Draft loaded") ||
        console.log("Draft loaded");
      }
    },

    resetForm() {
      if (confirm("Are you sure you want to reset the form? All entered data will be lost.")) {
        // Reset all data
        this.employee = {
          empNo: '',
          firstName: '',
          middleName: '',
          lastName: '',
          email: '',
          personalEmail: '',
          phone: '',
          nationalId: '',
          gender: '',
          dateOfBirth: '',
          nationality: 'Kenya',
          employmentType: '',
          hireDate: '',
          departmentID: '',
          departmentName: '',
          positionId: '',
          positionTitle: '',
          supervisorPositionId: '',
          reportingTo: ''
        };

        this.selectedPosition = null;
        this.errors = {};
      }
    },

    createAnother() {
      this.resetForm();
      window.scrollTo(0, 0);
    },

    createAnotherAndCloseModal() {
      this.showSuccessModal = false;
      this.createAnother();
    },

    gotTo(route) {
      this.$router.push(route);
    }
  },

  created() {
    // Check for draft on load
    const draft = localStorage.getItem('employeeDraft');
    if (draft) {
      if (confirm("A draft was found. Would you like to load it?")) {
        this.loadDraft();
      }
    }
  }
};
</script>

<style scoped>
/* Clear fixed sidebar (Navigation is 280px wide) */
#layout-wrapper {
  min-height: 100vh;
}
.content-minimize {
  margin-left: 280px;
  padding: 20px;
  transition: margin-left 0.3s ease;
}
@media (max-width: 992px) {
  .content-minimize {
    margin-left: 0;
    padding: 15px;
  }
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.form-control:focus,
.form-select:focus {
  border-color: #059669;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

.is-invalid {
  border-color: #f46a6a !important;
}

.badge {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.avatar-lg {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Loading state */
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Card hover effects */
.card {
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Input group styling */
.input-group-text {
  background-color: #f8f9fa;
  border-right: none;
}

.input-group .form-control,
.input-group .form-select {
  border-left: none;
}

.input-group:focus-within .input-group-text {
  border-color: #059669;
  color: #059669;
}

/* Modal overlay (no Bootstrap) */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-dialog-custom {
  max-width: 500px;
  width: 90%;
}
.modal-content-custom {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.modal-body-custom {
  padding: 24px;
}
.d-grid { display: flex; flex-direction: column; gap: 12px; }
.btn-outline-primary { background: transparent; border: 2px solid #059669; color: #059669; }
.btn-outline-primary:hover { background: #059669; color: white; }
</style>